export default {
    key: 'kleine-scheidegg',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    isLoadingPassengerOffers: true,
    isRental: false,
    origins: [],
    destinations: [
        {
            ref: 'urn:uic:stn:8507374',
            name: 'Kleine Scheidegg',
        },
    ],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    hidePassengerMeasurements: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: ['express', 'traditional-grin', 'traditional-laut'],
    routeVariantUp: 'default-kls',
    routeVariantDown: 'default-kls',
    upsells: [],
    isUpsellDatesRestricted: false,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 120,
    stayDurationMin: 60,
    salesTimeLimit: undefined,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: 10,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:ts:listing:db3ac919-e226-4430-9f01-e6c51de18085',
    contentfulId: 'kleine-scheidegg',
    steps: [],
} satisfies ProductConfigP2P;
